<template>
  <div class="box">
    <div class="is-flex is-justify-content-space-between is-align-items-center">
      <h4 class="title is-size-5 mr-5 mb-0">Job Titles</h4>
      <BaseDropdown
        v-if="!isSubmitted"
        :leftOffset="-10"
        wrapperClasses="column is-8 pt-0"
        dialogClass="p-0"
        :onDialogChange="chooseJobTitle"
      >
        <template v-slot:toggle-button="{ handleToggle }">
          <div @click="handleToggle" class="pick-job-title-container">
            ... בחר/י
          </div>
        </template>
        <div class="container py-3 px-2 max-width-dropdown">
          <input type="search" class="input" v-model="searchJobTitle" />
          <label v-for="jobTitle in dropdownJobTitles" :key="jobTitle.id">
            <input type="checkbox" name="skills" :value="jobTitle.id" hidden />
            <p class="search_result has-text-right">{{ jobTitle.name }}</p>
          </label>
        </div>
      </BaseDropdown>
    </div>
    <JobTitleRanksBar
      v-if="showRanks && selectedJobTitles.length"
      :ownerText="ranksOwnerText"
      :dirty="ranksDirty"
      :saving="ranksSaving"
      :message="rankMessage"
      @save="saveRanks"
    />
    <table class="table rtl" style="width: 100%">
      <tbody>
        <tr v-for="selected in orderedJobTitles" :key="selected.id" class="job-title-row" :data-job-title-id="selected.id">
          <td class="has-text-right">
            <div class="is-flex is-align-items-center">
              <span class="ml-6">{{ selected.name }}</span>
              <span v-if="isJobTitleDirty(selected)" class="tag is-warning is-light ml-3 job-title-unsaved">{{ jobTitleTexts.unsaved }}</span>
              <IsApproved v-if="selected.server" :applicantId="applicant.resource_id" :applicantJobTitle="selected" @updated="notifyParent"/>
            </div>
            <JobTitleRankCell
              v-if="showRanks"
              class="mt-2"
              :rank="rankOf(selected)"
              :canUp="canRank(selected)"
              :isPrimary="primaryId === selected.id"
              :editorText="editorTagOf(selected)"
              :radioName="primaryRadioName"
              @up="rankUp(selected)"
              @down="rankDown(selected)"
              @primary="setPrimary(selected)"
            />
            <div class="mt-3">
              <ApplicantComment :isEditable="!isSubmitted" :applicantId="applicant.resource_id" :applicantJobTitle="selected" @updated="notifyApplicantComment" />
            </div>
          </td>
          <td class="px-1" style="width: 240px">
            <div class="columns is-justify-content-space-between">
              <div
                class="column is-6"
                v-if="!isSubmitted && selected.experienceSelector == 'number'"
              >
                <input
                  class="input is-small"
                  :class="{
                    'is-danger':
                      selected.started_at === null ||
                      selected.started_at === '' ||
                      selected.started_at === undefined,
                  }"
                  type="number"
                  style="background-color: white !important"
                  placeholder="Started"
                  :value="selected.started_at"
                  @input="onStartedInput(selected, $event.target.value)"
                />
              </div>
              <div
                class="column is-6"
                v-else-if="
                  !isSubmitted && selected.experienceSelector == 'date'
                "
              >
                <input
                  class="input is-small"
                  :class="{
                    'is-danger':
                      selected.started_at === null ||
                      selected.started_at === '' ||
                      selected.started_at === undefined,
                  }"
                  type="date"
                  style="background-color: white !important"
                  :value="selected.started_at"
                  @input="onStartedInput(selected, $event.target.value)"
                />
              </div>
              <div class="column is-6" v-else>
                <p class="m-1">{{ getYearText(selected.started_at) }}</p>
              </div>
              <div v-if="isSubmitted" class="column">
                <JobTitleInterest :value="selected.interest_state" :states="interestStates" />
              </div>
              <div class="column pb-2 is-4" v-if="!isSubmitted">
                <BaseDropdown
                  :leftOffset="-10"
                  wrapperClasses="pb-1"
                  dialogClass="p-0"
                  :onDialogChange="toggleExpireinceSelector"
                >
                  <template v-slot:toggle-button="{ handleToggle }">
                    <button
                      class="button is-dark is-small is-fullwidth p-3"
                      @click="handleToggle"
                    >
                      {{ selected.experienceSelector }}
                    </button>
                  </template>
                  <div
                    class="py-3 max-width-dropdown-small is-flex is-flex-direction-column"
                  >
                    <label
                      class="radio m-3 is-flex is-justify-content-space-between"
                    >
                      <input
                        type="radio"
                        name="expirience-selector"
                        :value="`${selected.id}|no-exp`"
                      />
                      <span class="px-3">אין ניסיון</span>
                    </label>
                    <label
                      class="radio m-3 is-flex is-justify-content-space-between"
                    >
                      <input
                        type="radio"
                        name="expirience-selector"
                        :value="`${selected.id}|number`"
                      />
                      <span class="px-3">number</span>
                    </label>
                    <label
                      class="radio m-3 is-flex is-justify-content-space-between"
                    >
                      <input
                        type="radio"
                        name="expirience-selector"
                        :value="`${selected.id}|date`"
                      />
                      <span class="px-3">date</span>
                    </label>
                  </div>
                </BaseDropdown>
              </div>
              <div class="column is-2 px-0" v-if="!isSubmitted">
                <button
                  class="button is-danger is-small"
                  @click="removeJotTitle(selected)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-trash"
                    viewBox="0 0 20 20"
                  >
                    <g
                      xmlns="http://www.w3.org/2000/svg"
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="Dribbble-Light-Preview"
                        transform="translate(-179.000000, -360.000000)"
                        fill="#ffffff"
                      >
                        <g
                          id="icons"
                          transform="translate(56.000000, 160.000000)"
                        >
                          <path
                            d="M130.35,216 L132.45,216 L132.45,208 L130.35,208 L130.35,216 Z M134.55,216 L136.65,216 L136.65,208 L134.55,208 L134.55,216 Z M128.25,218 L138.75,218 L138.75,206 L128.25,206 L128.25,218 Z M130.35,204 L136.65,204 L136.65,202 L130.35,202 L130.35,204 Z M138.75,204 L138.75,200 L128.25,200 L128.25,204 L123,204 L123,206 L126.15,206 L126.15,220 L140.85,220 L140.85,206 L144,206 L144,204 L138.75,204 Z"
                            id="delete-[#1487]"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                </button>
              </div>
            </div>
            <div v-if="!isSubmitted">
              <Checkbox
                class="job-title-still-active"
                :checked="selected.still_active"
                @input="setStillActive(selected, $event)"
              >
                <span class="is-size-7">Still Active</span>
              </Checkbox>
              <JobTitleInterest
                class="mt-2"
                editable
                :value="selected.interest_state"
                :states="interestStates"
                @input="setInterest(selected, $event)"
              />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="!isSubmitted">
      <button
        class="button is-info is-fullwidth job-titles-submit"
        :class="{ 'is-loading': rowsSaving }"
        @click="submitJobTitles"
        :disabled="!valideJobTitles || rowsSaving"
      >
        Submit job titles
      </button>
    </div>
    <div v-if="isSubmitted">
      <button
        class="button is-info is-fullwidth"
        @click="updateJobTitles"
        :disabled="valideJobTitles"
      >
        Update job titles
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import BaseDropdown from '@/components/BaseDropdown'
import Checkbox from '@/components/Checkbox'
import IsApproved from '@/components/entities/applicantJobTitle/IsApproved'
import ApplicantComment from '@/components/entities/applicantJobTitle/ApplicantComment'
import JobTitleInterest from '@/components/entities/applicantJobTitle/JobTitleInterest'
import JobTitleRankCell from '@/components/entities/applicantJobTitle/JobTitleRankCell'
import JobTitleRanksBar from '@/components/entities/applicantJobTitle/JobTitleRanksBar'
import applicantJobTitlesMixin from '@/mixins/applicantJobTitlesMixin.js'

export default {
  name: 'JobTitles',
  components: {
    BaseDropdown,
    Checkbox,
    IsApproved,
    ApplicantComment,
    JobTitleInterest,
    JobTitleRankCell,
    JobTitleRanksBar
  },
  mixins: [applicantJobTitlesMixin],
  props: {
    applicant: {
      type: Object
    }
  },
  computed: {
    ...mapGetters('jobTitles', ['allJobTitles']),
    primaryRadioName () {
      return `job-title-primary-${this._uid}`
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      return this.loadJobTitles()
    },
    // ApplicantComment saves the comment itself; keep the local copy in sync only.
    notifyApplicantComment ({ id, value }) {
      const jobTitle = this.selectedJobTitles.find(j => j.id == id) // eslint-disable-line eqeqeq
      if (jobTitle) {
        jobTitle.applicant_comment = value
      }
    },
    async notifyParent (data) {
      this.init()
    }
  }
}
</script>

<style scoped>
  .max-width-dropdown {
    max-width: 500px;
    border: 2px solid rgba(0, 0, 0, 0.3);
  }
  .max-width-dropdown-small {
    max-width: 200px;
    border: 2px solid rgba(0, 0, 0, 0.3);
  }
  .pick-job-title-container {
    cursor: pointer;
    background: url('/black_down_arrow.svg') no-repeat;
    background-position-y: center;
    background-position-x: 10px;
    background-size: 15px;
    width: 100%;
    display: inline-block;
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    text-align: right;
  }
</style>
